import { render, staticRenderFns } from "./right-center.vue?vue&type=template&id=43939a9d&scoped=true"
import script from "./right-center.vue?vue&type=script&lang=ts"
export * from "./right-center.vue?vue&type=script&lang=ts"
import style0 from "./right-center.vue?vue&type=style&index=0&id=43939a9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43939a9d",
  null
  
)

export default component.exports